import angular from 'angular';

angular.module("merchant.application.main").factory("merchant.application.main.factory.merchant", [
    function() {

        var expose = {};

        return expose;
    }
]);
